module.exports = __webpack_public_path__ + "static/img/clause_letter133.750977c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter133.png
// module id = rcKB
// module chunks = 1